import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "height", "alt"];
// @ts-expect-error importing image ts(2307)
import hamburgerIcon from 'bender-url!../../../images/icons/hamburger-icon.svg';
import I18n from 'I18n';
import CUIBaseIcon from './CUIBaseIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const CUIHamburgerIcon = _ref => {
  let {
      width,
      height,
      alt
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIBaseIcon, Object.assign({
    iconSrc: hamburgerIcon,
    width: width,
    height: height,
    alt: alt || I18n.text('connect.marketingSite.header.aria-label')
  }, rest));
};
export default CUIHamburgerIcon;